/** Pure helpers for DetailPageTemplate — kept separate for react-refresh + tests. */

export type DetailTabRef = {
  id: string;
  disabled?: boolean;
};

/**
 * Canonical Ops detail tab order (R3.2 / Lớp A→B→C).
 * Pages still pass `tabs[]` explicitly; use this as the binding checklist.
 *
 * ```
 * overview → domain* (lines|contact|permissions|…) → related → documents → audit
 * ```
 */
export const DETAIL_TAB_ORDER = [
  "overview",
  "domain",
  "related",
  "documents",
  "audit",
] as const;

export type DetailTabSlot = (typeof DETAIL_TAB_ORDER)[number];

/** Tab label with optional count badge text: `Đơn bán (3)`. */
export function formatRelatedTabLabel(
  label: string,
  count: number | undefined,
): string {
  if (count == null || Number.isNaN(count)) return label;
  return `${label} (${count})`;
}

/**
 * Resolve which tab opens first.
 * Prefers `defaultTabId` when it exists and is enabled; else first enabled tab.
 */
export function resolveDetailDefaultTabId(
  tabs: DetailTabRef[],
  defaultTabId?: string,
): string | undefined {
  if (tabs.length === 0) return undefined;
  if (defaultTabId && tabs.some((t) => t.id === defaultTabId && !t.disabled)) {
    return defaultTabId;
  }
  return tabs.find((t) => !t.disabled)?.id ?? tabs[0]?.id;
}
